import { useEffect, useState, useCallback } from "react";

const fetchBlackList = async () => {
  try {
    const response = await fetch(
      `${process.env.PUBLIC_URL}/buttonBlackList.json`
    );
    if (!response.ok) throw new Error("Failed to load blacklist");
    return await response.json();
  } catch (error) {
    console.error("Error fetching button blacklist:", error);
    return [];
  }
};

const disableButton = (button) => {
  button.disabled = true;
  button.style.cursor = "default";
  button.style.opacity = "1";
  button.style.pointerEvents = "none";
};

const enableButton = (button) => {
  button.disabled = false;
  button.style.cursor = "pointer";
  button.style.pointerEvents = "auto";
};

const useButtonTimeout = (bubbles) => {
  const [buttonBlackList, setButtonBlackList] = useState([]);

  // Fetch blacklist once
  useEffect(() => {
    fetchBlackList().then(setButtonBlackList);
  }, []);

  const handleButtonClick = useCallback(
    (button, bubble) => {
      if (buttonBlackList?.includes(button.title)) {
        // Special case: wait for "OK" button
        const hiddenButtons = bubble.querySelectorAll(".ac-pushButton");
        hiddenButtons.forEach((hiddenBtn) => {
          if (hiddenBtn.title === "OK") {
            hiddenBtn.addEventListener(
              "click",
              () => disableButton(hiddenBtn),
              {
                once: true,
              }
            );
          }
        });
      }

      // Generic timeout behavior
      disableButton(button);
      setTimeout(() => enableButton(button), 5_000);
    },
    [buttonBlackList]
  );

  // Attach handlers whenever bubbles change
  useEffect(() => {
    if (!bubbles?.length) return;

    const prevBubble = bubbles[bubbles.length - 2];
    const currentBubble = bubbles[bubbles.length - 1];

    const prevButtons = prevBubble?.querySelectorAll(".ac-pushButton") ?? [];
    const currButtons = currentBubble?.querySelectorAll(".ac-pushButton") ?? [];

    // Disable previous buttons unless "Chat now" is present
    if (
      prevButtons.length &&
      !Array.from(prevButtons).some((btn) => btn.title === "Chat now")
    ) {
      prevButtons.forEach(disableButton);
    }

    // Attach click handlers to current buttons
    if (
      currButtons.length &&
      !Array.from(currButtons).some((btn) => btn.title === "Chat now")
    ) {
      currButtons.forEach((button) =>
        button.addEventListener(
          "click",
          () => handleButtonClick(button, currentBubble),
          {
            once: true, // prevent duplicate bindings
          }
        )
      );
    }

    // Cleanup listeners
    return () => {
      currButtons.forEach((button) => {
        button.replaceWith(button.cloneNode(true)); // quick way to remove listeners
      });
    };
  }, [bubbles.length, handleButtonClick]);
};

export default useButtonTimeout;
